<svelte:head>
    <style>
        @import url("https://fonts.googleapis.com/css?family=Ruda&display=swap");
    </style>
</svelte:head>
<script>
	import { _ } from 'svelte-i18n';
	import { addMessages, init } from "svelte-i18n";
  	import es from "./lang/es.json";
    import en from "./lang/en.json";
    import ca from "./lang/ca.json";
    import { onMount } from 'svelte';
    import { fade, fly } from 'svelte/transition';

    const getLanguage = () => navigator.userLanguage || (navigator.languages && navigator.languages.length && navigator.languages[0]) || navigator.language || navigator.browserLanguage || navigator.systemLanguage || 'en';
    const language = getLanguage() ? getLanguage() : 'es';

    if( language === "es" || language === "es-ES" ) {
        addMessages("es", es);
        init({ initialLocale: "es" });
    }
    else if( language === "ca" || language === "ca-ES" ) {
        addMessages("ca", ca);
        init({ initialLocale: "ca" });
    }
    else {
        addMessages("en", en);
        init({ initialLocale: "en" });
    }

    let loading = true;
	let darkModeOn = false;
    let card_display = 1;
    let cards_list = [
		{ title: $_("centralization"), content: $_("centralization_content"), img: "img/searches_index.png" },
		{ title: $_("real_time"), content: $_("real_time_content"), img: "img/search_info.png" },
        { title: $_("admin_incidents"), content: $_("admin_incidents_content"), img: "img/search_incidents_manager.png" },
        { title: $_("admin_resources"), content: $_("admin_resources_content"), img: "img/search_resources_manager.png" },
        { title: $_("admin_tasks"), content: $_("admin_tasks_content"), img: "img/search_tasks_manager.png" },
		{ title: $_("admin_users"), content: $_("admin_users_content"), img: "img/users_admin_logs.png" }
	];
    let team_list = [
		{ name: "Eduard Aymerich", img: "img/edu.png", position: $_("developer"), linkedin: "https://www.linkedin.com/in/eduayme" },
		{ name: "Albert Teixidó", img: "img/albert.png", position: $_("firefighter_20_experience") },
        { name: "Enric Sala", img: "img/enric.png", position: $_("firefighter_17_experience") }
	];

    function toggle() {
		window.document.body.classList.toggle('dark-mode');
		darkModeOn = !darkModeOn;
	}

    function sliderPrev() {
        if( card_display === 0 ) {
            card_display = (cards_list.length-1);
        }
        else {
            card_display--;
        }
    }

    function sliderNext() {
        if( card_display === (cards_list.length-1) ) {
            card_display = 0;
        }
        else {
            card_display++;
        }
    }

    onMount(() => loading = false);
</script>

<img src="img/RescueApp-logo-horizontal.png" class="logo-fill" alt="">
<h1> {$_("header")} </h1>
<h3> {$_("subheader_1")} </h3>
<h3> {$_("subheader_2")} </h3>

<div on:click={toggle} class="toggle-dark-mode">
	{#if darkModeOn}
		<svg className="w-8 h-8 md:w-10 md:h-10" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="40" height="40">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
            />
        </svg>
	{:else}
		<svg className="w-8 h-8 md:w-10 md:h-10" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="40" height="40">
		  <path
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
		  />
		</svg>
	{/if}
</div>

<!-- Begin Mailchimp Signup Form -->
<div id="mc_embed_signup">
    <form action="{__myapp.env.MAILCHIMP_ACTION}" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
        <div id="mc_embed_signup_scroll">

        <div class="mc-field-group">
        	<input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL" placeholder={$_("input_placeholder")}>
        </div>
    	<div id="mce-responses" class="clear">
    		<div class="response" id="mce-error-response" style="display:none"></div>
    		<div class="response" id="mce-success-response" style="display:none"></div>
    	</div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
        <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_6ce49d71459692b783444f2fa_4ed9be1bc6" tabindex="-1" value=""></div>
        <div class="clear"><input type="submit" value="{$_("input_submit")}" name="subscribe" id="mc-embedded-subscribe" class="submit-button"></div>
        </div>
    </form>
</div>
<!-- End mc_embed_signup -->

<div class="screens">
    {#if !loading}
        {#if darkModeOn}
            <img class="screens-img" src="img/screens-dark.png" alt="Screens"
            in:fly="{{ y: 100, duration: 100 }}" out:fade>
        {:else}
            <img class="screens-img" src="img/screens-light.png" alt="Screens"
            in:fly="{{ y: 100, duration: 100 }}" out:fade>
        {/if}
    {/if}
</div>

<h2> {$_("features")} </h2>
<p> {$_("features_subheader")} </p>
<div class="row">
    {#each cards_list as card, i}
        <div class="column-3">
            <div class="feature-card" on:click={() => card_display = i}>
                <div class="feature-card-title">{card.title}</div>
                <div class="feature-card-content">{card.content}</div>
            </div>
        </div>
    {/each}
</div>
<div class="arrow-prev" on:click={sliderPrev}>
    <img src="img/left-arrow.svg" alt="previous">
</div>
<div class="arrow-next" on:click={sliderNext}>
    <img src="img/right-arrow.svg" alt="next">
</div>
<img src={cards_list[card_display].img} class="screen-feature" alt="index" in:fly="{{ y: 100, duration: 100 }}" out:fade>

<h2 class="margin-top"> {$_("team")} </h2>
<p> {$_("team_subheader")} </p>
<div class="row">
    {#each team_list as member}
        <div class="column-3">
            <div class="member-card">
                <img src="{member.img}" class="member-card-img">
                <div class="member-card-name">{member.name}</div>
                <div class="member-card-position">{member.position}</div>
                <a href="{member.linkedin}" class="{'linkedin' in member ? '' : 'hidden'}" target="_blank">
                    <img src="img/icon-linkedin.svg">
                </a>
            </div>
        </div>
    {/each}
</div>

<h2 class="margin-top"> {$_("contact")} </h2>
<p> {$_("contact_subheader")} </p>


<div class="form-container">
    <form action="https://api.staticforms.xyz/submit" method="post" id="staticform">
      <!-- Replace with your StaticForms accessKey -->
      <input type="hidden" name="accessKey" value="{__myapp.env.FORM_TOKEN}">
      <input type="hidden" name="subject" value="Contact landing RescueApp">
      <!-- Replace with the url you want to redirect to -->
      <input type="hidden" name="redirectTo" value="https://rescueapp.vercel.app">
      <div class="field">
        <label class="label">{$_("email")}</label>
        <div class="control">
          <input class="input" type="email" name="email" placeholder="" required>
        </div>
      </div>
      <div class="field">
        <label class="label">{$_("subject")}</label>
        <div class="control">
          <input class="input" type="text" name="subject" placeholder="" required>
        </div>
      </div>
      <div class="field">
        <label class="label">{$_("message")}</label>
        <div class="control">
          <textarea class="textarea input" name="message" placeholder="" required></textarea>
        </div>
      </div>
      <button class="submit-button" type="Submit">{$_("send_message")}</button>
    </form>
</div>

<footer> <br> </footer>

<style>
    :root {
        --color-primary: #B30000;
        --color-secondary: #D9F2FF;
        --color-light: #FFFFFF;
        --color-dark: #131313;
    }
	@font-face {
		font-family: 'Ruda';
		font-style: normal;
		font-weight: 400;
		src: url(https://fonts.gstatic.com/s/ruda/v14/k3kKo8YQJOpFgHQ1mQ5VkEbUKaJFsh_90q-wHx-GrY1faQ.woff) format('woff');
		unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
	}

	:global(body) {
		font-family: 'Ruda';
		padding: 2rem 0.5rem 5rem 0.5rem;
		text-align: center;
		max-width: 1440px;
		margin: 0 auto;
		background-color: var(--color-light);
		color: var(--color-dark);
	}
	:global(body.dark-mode) {
		background-color: var(--color-dark);
		color: var(--color-light);
	}

	.toggle-dark-mode {
		position: fixed;
		top: 20px;
		right: 20px;
		cursor: pointer;
	}

	.logo-fill {
        margin-top: 20px;
        width: 400px;
        max-width: 90%;
	}

    h1, h2, h3 {
        max-width: 90%;
        text-align: center;
        margin: 0 auto;
    }

	h1 {
		font-family: Ruda;
		font-style: normal;
		font-weight: bold;
		font-size: 54px;
		line-height: 60px;
        max-width: 90%;
		padding: 1rem 0.5rem;
	}

    h2 {
        width: 1100px;
        max-width: 90%;
		padding: 1rem 0.5rem 1rem 0;
        text-transform: uppercase;
        font-size: 42px;
        line-height: 40px;
    }

    h3 {
        width: 1100px;
        max-width: 90%;
        padding: 0.5rem 1rem;
        font-size: 18px;
        line-height: 30px;
    }

    p {
        font-size: 16px;
        line-height: 20px;
        padding: 0.25rem;
    }

    #mc_embed_signup {
        position: relative;
        width: 600px;
        max-width: 90%;
        margin: 2rem auto;
    }

    #mce-EMAIL {
        width: 100%;
        padding: 0.55rem 1rem;
        border-radius: 6px;
    }
    #mc-embedded-subscribe {
        position: absolute;
        right: 0.125rem;
        top: 0.125rem;
    }
    .submit-button {
        background-color: var(--color-primary);
        color: var(--color-light);
        border-radius: 4px;
        border: none;
        padding: 0.5rem 1rem;
        cursor: pointer;
    }

    .arrow-prev,
    .arrow-next {
        display: inline-block;
        height: 40px;
        width: 40px;
        margin: -10px 50px 25px 50px;
        border-radius: 50%;
        opacity: 0.75;
    }

    .arrow-prev:hover,
    .arrow-next:hover {
        cursor: pointer;
        opacity: 1;
    }

    .screens-img,
    .screen-feature {
        width: 80vw;
        max-width: 90%;
        margin: 10px auto 100px auto;
    }

    .screen-feature {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
        border-radius: 8px;
    }

    .column-3 {
      float: left;
      width: 30.3333%;
      padding: 0 1.5%;
      margin: 20px 0;
    }

    .feature-card {
      height: 150px;
    }

    .column-2 {
      float: left;
      width: 45%;
      padding: 0 2.5%;
      margin: 20px 0;
    }

    .row {
        margin: 50px auto;
        width: 1200px;
        max-width: 100%;
    }

    .row:after {
      content: "";
      display: table;
      clear: both;
    }

    .feature-card {
      padding: 20px;
      text-align: left;
      border-radius: 4px;
    }

    .feature-card:hover {
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
      cursor: pointer;
    }

    .feature-card-title {
        color: var(--color-primary);
        font-size: 24px;
        margin-bottom: 20px;
    }

    .motive-content {
        text-align: left;
        line-height: 30px;
        font-size: 16px;
    }

    .data {
        margin-top: 30px;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        color: var(--color-primary);
    }
    .data-info {
        text-align: center;
    }

    .member-card-name {
        font-size: 18px;
        font-weight: bold;
        padding: 0.5rem 0;
    }

    .member-card-position {
        font-size: 14px;
        padding-bottom: 0.5rem;
    }

    .label {
        text-align: left;
        margin-top: 20px;
    }
    .input {
        width: 100%;
    }
    .form-container {
        width: 600px;
        max-width: 75%;
        margin: 50px auto;
        padding: 25px 50px;
        border-radius: 8px;
        background-color: rgb(217, 242, 255, 0.1);
    }

    footer {
        margin-top: 50px;
    }

    .hidden {
        visibility: hidden;
    }

    .margin-top {
        margin-top: 100px;
    }

	@media (max-width: 640px) {
		body {
			max-width: none;
		}
        h1 {
            font-size: 32px;
    		line-height: 40px;
        }
        #mc-embedded-subscribe {
            position: relative;
        }
        .screens-img {
            margin-bottom: 100px;
        }
        .row {
            margin-top: 20px;
        }
        .column-3,
        .column-2 {
          width: 97%;
          display: block;
          margin-bottom: 20px;
        }
        .feature-card {
            height: 100px;
        }
        .margin-top {
            margin-top: 50px;
        }
	}
</style>
